// extracted by mini-css-extract-plugin
export var card = "Q_cG";
export var cardContainer = "Q_cF";
export var infoBoxList = "Q_cD";
export var textContainer = "Q_cH";
export var title = "Q_br";